import { createReducer, on } from "@ngrx/store";
import * as BatchActions from "./batch.actions";
import { BatchState, initialBatchState } from "./batch.state";

export const batchReducer = createReducer(
    initialBatchState,
    
  on(BatchActions.loadAllBatches, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(BatchActions.loadAllBatchesSuccess, (state, { batches }) => ({
    ...state,
    batches,
    loading: false,
  })),
  on(BatchActions.loadAllBatchesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(BatchActions.loadBatches, (state) => ({ ...state, loading: true })),
  on(BatchActions.loadBatchesSuccess, (state, { batches }) => ({
    ...state,
    loading: false,
    batches,
  })),
  on(BatchActions.loadBatchesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(BatchActions.createBatchSuccess, (state, { batch }) => ({
    ...state,
    batches: [...state.batches, batch],
  })),

  on(BatchActions.updateBatchSuccess, (state, { batch }) => ({
    ...state,
    batches: state.batches.map((b) => (b.id === batch.id ? batch : b)),
  })),

  on(BatchActions.deleteBatchSuccess, (state, { id }) => ({
    ...state,
    batches: state.batches.filter((b) => b.id !== id),
  }))
);
